export const LINKS = {
  whatsappNumber: "6285161201807",
  instagram: "https://instagram.com/vinslab.maker",
  tiktok: "https://tiktok.com/@vinslab.maker",
  youtube: "https://youtube.com/@vinslabmaker",
};

export const waLink = (text) =>
  `https://wa.me/${LINKS.whatsappNumber}?text=${encodeURIComponent(text)}`;

export const SERVICE_COLORS = { figure: "#22C55E", part: "#8B5CF6", design: "#FF2E4D" };

export const WORKS = [
  { id: "knight", img: "/img/knight.webp", cat: "figure", span: "lg:col-span-4 lg:row-span-2 md:row-span-2", title: { id: "Ksatria Kolektor", en: "Collector Knight" }, spec: "Resin · 0.05mm · hand-painted" },
  { id: "board", img: "/img/board.webp", cat: "design", span: "lg:col-span-8", title: { id: "Set Papan Permainan Lokal", en: "Local Board Game Set" }, spec: "PLA+ · tiles, tokens, organizer" },
  { id: "dragon", img: "/img/dragon.webp", cat: "figure", span: "lg:col-span-4", title: { id: "Naga Miniatur", en: "Dragon Miniature" }, spec: "Resin · 0.05mm" },
  { id: "mech", img: "/img/mech.webp", cat: "part", span: "lg:col-span-4", title: { id: "Modul Roda Gigi", en: "Gear Module" }, spec: "PETG · functional fit" },
  { id: "chess", img: "/img/chess.webp", cat: "design", span: "lg:col-span-8", title: { id: "Set Catur Custom", en: "Custom Chess Set" }, spec: "PLA matte · two-tone" },
  { id: "printer", img: "/img/printer.webp", cat: "part", span: "lg:col-span-4 lg:row-span-2 md:row-span-2", title: { id: "Di Balik Nozzle", en: "Behind the Nozzle" }, spec: "FDM · layer by layer" },
  { id: "chest", img: "/img/chest.webp", cat: "design", span: "lg:col-span-4", title: { id: "Peti Harta & Benchy", en: "Treasure Chest & Benchy" }, spec: "PLA · print-in-place" },
  { id: "banner", img: "/img/banner.webp", cat: "studio", span: "lg:col-span-4", title: { id: "Studio Vinslab", en: "Vinslab Studio" }, spec: "Create. Print. Make It Real." },
];

export const MATERIALS = [
  { name: "PLA+", strength: 3, flex: 1, detail: 4, use: { id: "Figur, dekorasi, prototipe", en: "Figures, decor, prototypes" } },
  { name: "PETG", strength: 4, flex: 2, detail: 3, use: { id: "Part fungsional, outdoor", en: "Functional parts, outdoor" } },
  { name: "TPU", strength: 3, flex: 5, detail: 2, use: { id: "Karet, grip, peredam", en: "Rubbery grips, dampers" } },
  { name: "ABS", strength: 4, flex: 2, detail: 3, use: { id: "Tahan panas, casing", en: "Heat-resistant enclosures" } },
  { name: "Resin", strength: 2, flex: 1, detail: 5, use: { id: "Miniatur super detail", en: "Ultra-detailed minis" } },
];

export const T = {
  id: {
    nav: { work: "Karya", reel: "Video", services: "Layanan", process: "Proses", materials: "Material", order: "Order" },
    navCta: "DM Kami",
    heroEyebrow: "Studio cetak 3D · Indonesia",
    heroLines: ["Vinslab", "Maker"],
    heroScript: "Create. Print. Make It Real.",
    heroSub: "Dari sketsa di kepala jadi benda di tanganmu. Miniatur, part custom, dan desain board game — dicetak layer demi layer.",
    heroCta: "Pesan via WhatsApp",
    heroCta2: "Lihat karya",
    heroBadge: "Antrean dibuka",
    marquee: ["Miniature & Figure", "Custom Part", "Custom Design", "From Idea to Reality", "Board Game Lokal", "Layer by Layer"],
    servicesEyebrow: "01 — Layanan",
    servicesTitle: "Tiga cara mewujudkan idemu.",
    services: [
      { key: "figure", title: "Miniature & Figure", desc: "Karakter, koleksi, diorama, dan lainnya." },
      { key: "part", title: "Custom Part", desc: "Berbagai komponen teknis sesuai kebutuhan." },
      { key: "design", title: "Custom Design", desc: "Tile, token, organizer, dan komponen permainan papan buatan lokal." },
    ],
    serviceAsk: "Tanya layanan ini",
    workEyebrow: "02 — Portofolio",
    workTitle: "Hasil cetak dari meja studio.",
    reelEyebrow: "03 — Dari Meja Studio",
    reelTitle: "Lihat mesinnya bekerja.",
    reelCaps: ["Cetak multiwarna satu jalur", "Grid structure, layer demi layer"],
    filters: { all: "Semua", figure: "Figure", part: "Part", design: "Design" },
    processEyebrow: "04 — Cara Order",
    processTitle: "Empat langkah, tanpa ribet.",
    steps: [
      { t: "Kirim ide", d: "Kirim file STL/OBJ/3MF, sketsa, atau foto referensi lewat WhatsApp atau DM." },
      { t: "Diskusi & harga", d: "Kami bahas ukuran, material, dan warna, lalu kirim penawaran." },
      { t: "Cetak", d: "Objekmu dicetak layer demi layer dan dicek sebelum dikemas." },
      { t: "Terima", d: "Ambil langsung atau kirim ke alamatmu." },
    ],
    materialsEyebrow: "05 — Material",
    materialsTitle: "Pilih filamen yang tepat.",
    matCols: ["Kekuatan", "Fleksibel", "Detail", "Cocok untuk"],
    orderEyebrow: "06 — Order",
    orderTitle: "Susun pesananmu, kirim dalam satu tap.",
    orderService: "Layanan",
    orderMaterial: "Material",
    orderMaterialUnsure: "Belum tahu",
    orderQty: "Jumlah",
    orderNote: "Ceritakan idemu",
    orderNotePh: "Contoh: figur karakter 10cm, warna merah, untuk hadiah...",
    orderPreview: "Pratinjau pesan",
    orderSend: "Kirim ke WhatsApp",
    orderOr: "Atau DM kami di",
    waGreeting: "Halo Vinslab Maker! Saya mau order cetak 3D.",
    faqEyebrow: "07 — FAQ",
    faqTitle: "Pertanyaan yang sering muncul.",
    faqs: [
      { q: "Saya tidak punya file 3D, bisa order?", a: "Bisa. Kirim sketsa atau foto referensi, kami bantu lewat layanan Custom Design." },
      { q: "Format file apa yang diterima?", a: "STL, OBJ, dan 3MF. Kalau formatmu lain, kirim saja dulu — kami cek." },
      { q: "Berapa lama proses cetaknya?", a: "Tergantung ukuran, jumlah, dan antrean. Estimasi waktu kami sampaikan bersama penawaran harga." },
      { q: "Bagaimana cara bayarnya?", a: "Detail pembayaran dikirim saat penawaran disetujui lewat WhatsApp." },
    ],
    footerLine: "Dari ide menjadi nyata.",
    rights: "Semua hak dilindungi.",
  },
  en: {
    nav: { work: "Work", reel: "Video", services: "Services", process: "Process", materials: "Materials", order: "Order" },
    navCta: "DM Us",
    heroEyebrow: "3D printing studio · Indonesia",
    heroLines: ["Vinslab", "Maker"],
    heroScript: "Create. Print. Make It Real.",
    heroSub: "From the sketch in your head to the object in your hand. Miniatures, custom parts and board game designs — printed layer by layer.",
    heroCta: "Order on WhatsApp",
    heroCta2: "See the work",
    heroBadge: "Queue open",
    marquee: ["Miniature & Figure", "Custom Part", "Custom Design", "From Idea to Reality", "Local Board Games", "Layer by Layer"],
    servicesEyebrow: "01 — Services",
    servicesTitle: "Three ways to make your idea real.",
    services: [
      { key: "figure", title: "Miniature & Figure", desc: "Characters, collectibles, dioramas and more." },
      { key: "part", title: "Custom Part", desc: "Technical components made to fit your needs." },
      { key: "design", title: "Custom Design", desc: "Tiles, tokens, organizers and locally made board game components." },
    ],
    serviceAsk: "Ask about this",
    workEyebrow: "02 — Portfolio",
    workTitle: "Fresh off the studio bench.",
    reelEyebrow: "03 — From the studio floor",
    reelTitle: "Watch the machines work.",
    reelCaps: ["Single-pass multi-colour print", "Grid structure, layer by layer"],
    filters: { all: "All", figure: "Figure", part: "Part", design: "Design" },
    processEyebrow: "04 — How to order",
    processTitle: "Four steps, zero hassle.",
    steps: [
      { t: "Send your idea", d: "Share an STL/OBJ/3MF file, a sketch or reference photos via WhatsApp or DM." },
      { t: "Specs & quote", d: "We talk size, material and colour, then send you a quote." },
      { t: "Print", d: "Your object is printed layer by layer and checked before packing." },
      { t: "Receive", d: "Pick it up or have it shipped to your door." },
    ],
    materialsEyebrow: "05 — Materials",
    materialsTitle: "Pick the right filament.",
    matCols: ["Strength", "Flexibility", "Detail", "Best for"],
    orderEyebrow: "06 — Order",
    orderTitle: "Build your order, send it in one tap.",
    orderService: "Service",
    orderMaterial: "Material",
    orderMaterialUnsure: "Not sure",
    orderQty: "Quantity",
    orderNote: "Tell us your idea",
    orderNotePh: "E.g. 10cm character figure, red, as a gift...",
    orderPreview: "Message preview",
    orderSend: "Send to WhatsApp",
    orderOr: "Or DM us on",
    waGreeting: "Hi Vinslab Maker! I'd like to order a 3D print.",
    faqEyebrow: "07 — FAQ",
    faqTitle: "Questions people ask.",
    faqs: [
      { q: "I don't have a 3D file — can I still order?", a: "Yes. Send a sketch or reference photo and we'll help through our Custom Design service." },
      { q: "Which file formats do you accept?", a: "STL, OBJ and 3MF. If yours is different, send it anyway and we'll check." },
      { q: "How long does printing take?", a: "It depends on size, quantity and queue. We share a time estimate together with the quote." },
      { q: "How do I pay?", a: "Payment details are sent over WhatsApp once you approve the quote." },
    ],
    footerLine: "From idea to reality.",
    rights: "All rights reserved.",
  },
};
